<template>
  <LayoutDefault>
    <section class="information-documents">
      <h1 class="information-documents__title">Документы</h1>
      <div class="documents">
        <div class="documents__content"
          v-for="(document, idx) in documents"
          :key="idx"
        >
          <h2 class="documents__name">{{ document.name }}</h2>
          <span class="documents__link">{{ document.link }}</span>
        </div>
      </div>
      <div class="examination">
        <div class="examination__wrapper">
          <div class="examination__content"
            v-for="(item, idx) in examination"
            :key="idx"
          >
            <h2 class="examination__title">{{ item.name }}</h2>
            <Textarea
              v-model="item.description"
              rows="4"
              cols="40"
              autoResize="false"
              @change="test"
            />
          </div>
        </div>
        <span class="examination__link">Predosteregheniye.pdf</span>
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
import LayoutDefault from '@/layout/LayoutDefault'
import { ref } from 'vue'

import Textarea from 'primevue/textarea'

export default {
  name: 'DocumentsView',
  components: {
    LayoutDefault,
    Textarea
  },
  props: {
  },
  setup () {
    const documents = ref([
      {
        id: 1,
        name: 'Устав образовательной организации',
        link: 'Ustav_2019.pdf'
      },
      {
        id: 2,
        name: 'Правила внутреннего распорядка обучающихся',
        link: 'Pravila_vutrennego_rasporyadka_Obuch.pdf'
      },
      {
        id: 3,
        name: 'Правила внутреннего трудового распорядка',
        link: 'Pravila_vutrennego_rasporyadka_UC.pdf'
      },
      {
        id: 4,
        name: 'Договор (при наличии)',
        link: 'Отсутствует'
      },
      {
        id: 5,
        name: 'Отчёт о результатах самообследования 2022 год',
        link: 'Otchet_o_camoobsledovanii_2022.pdf'
      },
      {
        id: 6,
        name: 'Отчёт о результатах самообследования 2021 год',
        link: 'Otchet_o_camoobsledovanii_2021.pdf'
      },
      {
        id: 7,
        name: 'Отчёт о результатах самообследования 2020 год',
        link: 'Otchet_o_camoobsledovanii_2020.pdf'
      },
      {
        id: 8,
        name: 'Отчёт о результатах самообследования 2019 год',
        link: 'Otchet_o_camoobsledovanii_2019.pdf'
      },
      {
        id: 9,
        name: 'Отчёт о результатах самообследования 2018 год',
        link: 'Otchet_o_camoobsledovanii_2018.pdf'
      },
      {
        id: 10,
        name: 'Предписания органов, осуществляющих государственный контроль (надзор) в сфере образования, отчеты об исполнении таких предписаний (до подтверждения органом, осуществляющим государственный контроль (надзор) в сфере образования, исполнения предписания или признания его недействительным в установленном законом порядке) (при наличии)',
        link: 'Отсутствует'
      },
      {
        id: 11,
        name: 'Правила приёма обучающихся',
        link: 'Pravila_priema_otchisleniya.pdf'
      },
      {
        id: 12,
        name: 'Режим занятий обучающихся',
        link: 'Pologhenie_o_reghime_zanyatiy_2021.pdf'
      },
      {
        id: 13,
        name: 'Формы, периодичность и порядок текущего контроля успеваемости и промежуточной аттестации обучающихся',
        link: 'Pologhenie_o_kontrole_itogovoy_attestacii.pdf'
      },
      {
        id: 14,
        name: 'Порядок оформления возникновения, приостановления и прекращения отношений между образовательной организацией и обучающимися и(или) родителями (законными представителями) несовершеннолетних обучающихся',
        link: 'Отсутствует'
      },
      {
        id: 15,
        name: 'Дополнительно',
        link: 'Отсутствует'
      }
    ])

    const examination = ref([
      {
        id: 1,
        name: 'Дата проведения проверки',
        description: '28.07.2021'
      },
      {
        id: 2,
        name: 'Проверяющая организация',
        description: 'Министерство образования по Саратовской области Комитет по государственному контролю и надзору в сфере образования'
      },
      {
        id: 3,
        name: 'Вид проверки',
        description: 'Мониторинг'
      },
      {
        id: 5,
        name: 'Предписание',
        description: 'Предостережение о недопустимости нарушения обязательных требований от 28.07.2021 № 00617'
      },
      {
        id: 6,
        name: 'Отчёт',
        description: 'Отчет об исполнении предостережения'
      }
    ])

    return {
      documents,
      examination
    }
  }
}
</script>

<style lang="scss" scoped>
.information-documents {
  &__title {
    @include information-block-title;
    margin-bottom: 20px;
  }

  .documents {
    display: grid;
    grid-template-columns: repeat(2, 40%);
    grid-template-rows: repeat(10, auto);
    grid-auto-flow: column;
    column-gap: 85px;
    row-gap: 16px;
    margin-bottom: 30px;

    &__name {
      width: 40%;
      font-size: 14px;
      line-height: 18px;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &__content {
      display: flex;
      gap: 16px;
    }

    &__link {
      color: #1BA6DA;
      cursor: pointer;
    }
  }

  .examination {
    display: flex;
    flex-direction: column;

    &__wrapper {
      display: flex;
      gap: 16px;
    }

    &__content {
      margin-bottom: 10px;
    }

    &__title {
      margin-bottom: 12px;
      font-size: 18px;
      font-weight: 500;
      text-align: left;
    }

    &__link {
      color: #1BA6DA;
      cursor: pointer;
    }

    :deep(.p-inputtextarea) {
      padding: 8px 12px;
      font-size: 14px;
      line-height: 18px;
    }
  }
}
</style>
